// extracted by mini-css-extract-plugin
module.exports = {"marketStatus":"_d001137","marketStatusIcon":"_24bce73","noTextDecoration":"_4ab5b5e"};